module.exports = __webpack_public_path__ + "img/search.354623a6.svg";